import { AnimatePresence } from "framer-motion";
import React, { useEffect, useState, useCallback } from "react";
import { Routes, Route, useNavigate, useLocation, useParams } from "react-router-dom";
import { Toast } from "../../Components";

import ReportMain from "./ReportMain";
import ModalReportConfirm from "./ModalReportConfirm";
import ReportInsight from "./ReportInsight";
import CreateReport from "./CreateReport";
import NotSubscribe from "../../Components/Base/Common/NotSubscribe";
import { commonapiService, reportService } from "../../Services";
import { storageHandler } from "../../Helpers/storage";

const selectDescList = [
  { id: "title", value: "Title" },
  { id: "status", value: "Status" },
];
export default function Report({
  setAuth,
  NotifModul,
  user,
  profiles,
  setModalNotification,
  closeCartPanel,
  cartItem,
  goToPricing,
  setCustomTitle,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  // eslint-disable-next-line
  const { id: reportId } = useParams();
  const [selectDesc, setselectDesc] = useState(selectDescList[0].id);
  const [isloaded, setIsLoaded] = useState(false);
  const [page, setPage] = useState(1);
  // eslint-disable-next-line
  const [pageSize, setPageSize] = useState(20);
  const [platform, setPlatform] = useState([]);
  const [reportData, setReportData] = useState([]);
  const [toastList, setToastList] = useState([]);
  const [paginationData, setPaginationData] = useState({});
  const [searchList, setSearchList] = useState(false);
  const [searchString, setSearchString] = useState("");
  const [selectedReport, setSelectedReport] = useState();
  const [modal, setModal] = useState(null);
  const [disableSearchBox, setDisableSearchBox] = useState(false);
  const [filterTab, setFilterTab] = useState(() => {
    return localStorage.getItem('reportFilterTab') || 'all';
  });
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [confirmFor, setConfirmFor] = useState(null);
  const [platformToShow, setPlatformToShow] = useState("");
  // eslint-disable-next-line
  const [statusActivePaused, setStatusActivePaused] = useState("");
  const [tokenAvailable, setTokenAvailable] = useState(0);
  const [isTokenLoaded, setIsTokenLoaded] = useState(false);
  const [isUserHasSubscription, setUserHasSubscription] = useState(false);
  const [currentStatus, setCurrentStatus] = useState("");
  // eslint-disable-next-line
  const [customHeaderTitle, setCustomHeaderTitle] = useState(null);
  const [reportToUpdate, setReportToUpdate] = useState(null);
  const [isEditPage, setIsEditPage] = useState(false);
  const [reachedEnd, setReachedEnd] = useState(false);

  // Track if we're on edit page
  useEffect(() => {
    const isEditRoute = location.pathname.includes('/edit/');
    setIsEditPage(isEditRoute);
    // eslint-disable-next-line
  }, [location.pathname]);

  // Add the callback function
  const handleHeaderTitleChange = (title) => {
    setCustomHeaderTitle(title);
    setCustomTitle && setCustomTitle(title);
  };

  useEffect(() => {
    if (location.pathname === "/brand/reports" || location.pathname === "/brand/reports/") {
      setCustomTitle && setCustomTitle(null);
      setCustomHeaderTitle(null);
    }
    // eslint-disable-next-line
  }, [location.pathname]);

  useEffect(() => {
    if (modal) {
      document.body.classList.add("active");
    } else {
      document.body.classList.remove("active");
    }
    // eslint-disable-next-line
  }, [modal]);

  const fetchData = async (isLoadMore = false) => {
    try {
      if (isLoadMore) {
        setIsLoadingMore(true);
        setReachedEnd(false);
      } else {
        setIsLoaded(false);
        setPage(1);
        setReachedEnd(false);
      }

      let filterParams = [];

      if (searchString !== "") {
        filterParams.push("filter[" + selectDesc + "]=" + searchString);
      }

      const currentPage = isLoadMore ? page + 1 : 1;

      // Map tab to API status parameter
      const tabToStatusMap = {
        archive: "archived",
        nonarchive: "active", 
      };

      // Only add status filter if it's NOT "all" tab
      if (filterTab !== "all") {
        const apiStatus = tabToStatusMap[filterTab];
        if (apiStatus) {
          filterParams.push(`filter[status]=${apiStatus}`);
        }
      }

      const res = await reportService.getAll({
        page: currentPage,
        pageSize,
        filter: filterParams.length > 0 ? filterParams.join("&") : "",
      });

      if (res && res["meta"] && res["meta"]["pagination"]) {
        const pagination = res["meta"]["pagination"];
        setPaginationData(pagination);
        setHasMore(pagination.current_page < pagination.total_pages);
        
        // Check if we've reached the end
        if (pagination.current_page >= pagination.total_pages) {
          setReachedEnd(true);
        }
      } else {
        setHasMore(false);
        setReachedEnd(true);
      }

      const newData = res?.data?.data || [];
      
      // Check if this is the first page and no data
      if (!isLoadMore && newData.length === 0) {
        setReachedEnd(true);
      }
      
      if (isLoadMore) {
        setReportData((prev) => [...prev, ...newData]);
        setPage(currentPage);
      } else {
        setReportData(newData);
      }

      setIsLoaded(true);
      setIsLoadingMore(false);
    } catch (err) {
      console.error("Fetch error:", err);
      addToast({
        error: true,
        msg: err.message || err.toString() || "An error occurred",
        id: `${Date.now()}-${toastList.length}`,
      });
      setIsLoaded(true);
      setIsLoadingMore(false);
      setHasMore(false);
      setReachedEnd(true);
    }
  };

  useEffect(() => {
    if (location.pathname === "/brand/reports" || location.pathname === "/brand/reports/") {
      fetchData();
    }
    // eslint-disable-next-line
  }, [searchList, filterTab, location.pathname]);

  const loadMore = () => {
    if (!isLoadingMore && hasMore) {
      fetchData(true);
    }
  };
  
  useEffect(() => {
    setUserHasSubscription(
      user !== null
        ? user.data.isUserHasSubscription === 1
          ? true
          : false
        : false
    );
    // eslint-disable-next-line
  }, [user]);
  
  useEffect(() => {
    async function gettokenData() {
      try {
        const res = await reportService.getTokenData();
        setTokenAvailable(res.data[0]);
        setIsTokenLoaded(true);
      } catch (err) {
        addToast({
          error: true,
          msg: err.message || err.toString() || "An error occurred while getting token data",
          id: `${Date.now()}-${toastList.length}`,
        });
      }
    }

    gettokenData();
    // eslint-disable-next-line
  }, []);

  const onPaginate = (page) => {
    setPage(page);
  };

  const addToast = (data) => {
    const newToastList = [...toastList];
    newToastList.push({ ...data, id: `${Date.now()}-${toastList.length}` });
    setToastList(newToastList);
  };
  
  useEffect(() => {
    const keyDownHandler = (event) => {
      if (event.key === "Enter") {
        search();
      }
    };
    document.addEventListener("keydown", keyDownHandler);
    return () => {
      document.removeEventListener("keydown", keyDownHandler);
    };
    // eslint-disable-next-line
  }, [searchString]);

  const changeMediumDesc = (item) => {
    setselectDesc(item.id);
    setPage(1);
    if (item.id === "lastyr" || item.id === "30days") {
      setDisableSearchBox(true);
    } else {
      setDisableSearchBox(false);
    }
    setSearchString("");
    setSearchList(!searchList);
  };

  useEffect(() => {
    async function fetchCategoriesData() {
      try {
        const res = await commonapiService.getConfigData();
        console.log(res);
        let platformDetails = res.socialMedia;
        setPlatform(platformDetails);
        setIsLoaded(true);
      } catch (err) {
        addToast({
          error: true,
          msg: err.message || err.toString() || "An error occurred while fetching categories",
          id: `${Date.now()}-${toastList.length}`,
        });
      }
    }
    fetchCategoriesData();
    // eslint-disable-next-line
  }, []);

  const setSearchStringText = (event) => {
    if (event.target.value === "") {
      setSearchList(!searchList);
    }
    setSearchString(event.target.value);
  };
  
  const search = () => {
    setSearchList(!searchList);
    setPage(1);
  };

  const restoreReport = (id) => {
    setReportToUpdate(id);
    setConfirmFor("restore");
    setModal("confirm");
  };
  
  const archiveReport = (id) => {
    setReportToUpdate(id);
    setConfirmFor("archived");
    setModal("confirm");
  };
  
  const onConfirm = async () => {
    try {
      const status = confirmFor === "restore" ? "paused" : confirmFor;
      await updateStatus(reportToUpdate, status);
    } catch (error) {
      console.error("Confirm error:", error);
    }
  };

  const openViewReport = (item) => {
    console.log("🚀 ~ openViewReport ~ item:", item)
    setSelectedReport(item);
    let platformUsed = platform.filter(
      (platformData) => platformData.id === item.platform_id
    );
    setPlatformToShow(platformUsed[0]?.name || "");
    navigate(`insights/${item.id}`);
    handleHeaderTitleChange(item.title || "Report Details");
  };

  async function editReport(item) {
    console.log("🚀 ~ editReport ~ item:", item)
    if (item.id !== "") {
      try {
        const res = await reportService.getReport(item.id);
        console.log("🚀 ~ editReport ~ res:", res)
        const reportData = res.data; // Data is directly in res.data, not res.data[0]
        reportData["start_date"] =
          reportData["start_date"] && reportData["start_date"] !== ""
            ? new Date(reportData["start_date"])
            : "";
        reportData["end_date"] =
          reportData["end_date"] && reportData["end_date"] !== ""
            ? new Date(reportData["end_date"])
            : "";



        // Process influencers from ReportItem array
        let influencerData = [];
        if (reportData.ReportItem && reportData.ReportItem.length > 0) {
          reportData.ReportItem.forEach((item, index) => {
            influencerData.push({
              key: Date.now() + index,
              infHandle: item.infHandle || "",
              influencer_handle: item.infHandle || "", // Add for compatibility
              hash_tag: item.hashtag || "",
              hashtag: item.hashtag || "", // Add for compatibility
              token: 0,
            });
          });
          reportData["influencer_report"] = influencerData;
        }

        setSelectedReport(reportData);
        navigate(`edit/${item.id}`);
        handleHeaderTitleChange("Edit Report");
        setIsLoaded(true);
      } catch (err) {
        addToast({
          error: true,
          msg: err.message || err.toString() || "An error occurred while editing the report",
          id: `${Date.now()}-${toastList.length}`,
        });
      }
    }
  }

  async function updateStatus(reportId, status) {
    console.log("🚀 ~ updateStatus ~ status:", status, "reportId:", reportId)
    try {
      if (!reportId) {
        addToast({
          error: true,
          msg: "Report ID is missing",
          id: `${Date.now()}-${toastList.length}`,
        });
        return;
      }

      const res = await reportService.updateStatus(reportId, status);
      if (res) {
        setCurrentStatus(status);
        addToast({
          error: false,
          msg: res.message,
          id: `${Date.now()}-${toastList.length}`,
        });
        setModal(null);

        // Refresh the data
        fetchData();

        // Navigate if needed
        if (status === "archived" || (status === "paused" && isEditPage) || status === "active") {
          navigate("/brand/reports");
        }
      }
    } catch (err) {
      console.error("Update status error:", err);
      addToast({
        error: true,
        msg: err.message || "An error occurred while updating status",
        id: `${Date.now()}-${toastList.length}`,
      });
    }
  }

  const refreshReports = useCallback(() => {
    fetchData();
    // eslint-disable-next-line
  }, [filterTab, searchString, selectDesc, pageSize]);

  let userData = null;
  try {
    const userInfo = storageHandler.getUserInfo();
    if (userInfo) {
      const parsed = JSON.parse(userInfo);
      userData = parsed?.data || null;
    }
  } catch (error) {
    console.error("Error parsing user info:", error);
  }

  return (
    <>
      {isUserHasSubscription && userData?.p_f_ids?.includes(2) && (
        <>
          <div className="main">
            <div className="main__inner">
              <Routes>
                <Route
                  index
                  element={
                    <ReportMain
                      setTab={(tab) => {
                        if (tab === "create") navigate("create");
                        else if (tab === "main") navigate("/brand/reports");
                      }}
                      reportData={reportData}
                      setSearchStringText={setSearchStringText}
                      searchString={searchString}
                      paginationData={paginationData}
                      onPaginate={onPaginate}
                      disableSearchBox={disableSearchBox}
                      changeMediumDesc={changeMediumDesc}
                      editReport={editReport}
                      openViewReport={openViewReport}
                      search={search}
                      onHeaderTitleChange={handleHeaderTitleChange}
                      isLoading={!isloaded}
                      isLoadingMore={isLoadingMore}
                      hasMore={hasMore}
                      loadMore={loadMore}
                      selectedTab={filterTab}
                      setSelectedTab={(tab) => {
                        if (searchString !== "") {
                          setSearchString("");
                        }
                        setFilterTab(tab);
                        localStorage.setItem('reportFilterTab', tab);
                        // Removed the background API call
                      }}
                      reachedEnd={reachedEnd}
                    />
                  }
                />
                <Route
                  path="insights/:id"
                  element={
                    <>
                      <ReportInsight
                        setTab={() => navigate("/brand/reports")}
                        modalData={selectedReport}
                        platformToShow={platformToShow}
                        onHeaderTitleChange={handleHeaderTitleChange}
                      />
                    </>
                  }
                />
                <Route
                  path="edit/:id"
                  element={
                    <>
                      {isTokenLoaded && (
                        <CreateReport
                          tokenAvailable={tokenAvailable}
                          platform={platform}
                          restoreReport={restoreReport}
                          archiveReport={archiveReport}
                          statusActivePaused={statusActivePaused}
                          setConfirmFor={setConfirmFor}
                          currentStatus={currentStatus}
                          updateStatus={updateStatus}
                          tab="edit"
                          setTab={() => navigate("/brand/reports")}
                          setToastList={setToastList}
                          addToast={addToast}
                          toastList={toastList}
                          setSelectedReport={setSelectedReport}
                          selectedReport={selectedReport}
                          onHeaderTitleChange={handleHeaderTitleChange}
                          refreshReports={refreshReports}
                        />
                      )}
                    </>
                  }
                />
                <Route
                  path="create"
                  element={
                    isTokenLoaded && (
                      <CreateReport
                        tokenAvailable={tokenAvailable}
                        platform={platform}
                        restoreReport={restoreReport}
                        archiveReport={archiveReport}
                        setConfirmFor={setConfirmFor}
                        currentStatus={currentStatus}
                        updateStatus={updateStatus}
                        tab="create"
                        setTab={() => navigate("/brand/reports")}
                        setToastList={setToastList}
                        addToast={addToast}
                        toastList={toastList}
                        onHeaderTitleChange={handleHeaderTitleChange}
                        refreshReports={refreshReports}
                      />
                    )
                  }
                />
              </Routes>
            </div>
          </div>
          <AnimatePresence>
            {modal === "confirm" && (
              <ModalReportConfirm
                close={() => setModal(null)}
                onConfirm={onConfirm}
                confirmFor={confirmFor}
              />
            )}
          </AnimatePresence>
          {toastList && <Toast list={toastList} setList={setToastList} />}
        </>
      )}
      {isUserHasSubscription === false && user !== null && (
        <>
          <NotSubscribe
            goToPricing={goToPricing}
            type="brand"
            setAuth={setAuth}
            setModal={setModal}
            NotifModul={NotifModul}
            setNotifModul={setModalNotification}
            profiles={profiles}
            closeCartPanel={closeCartPanel}
            user={user}
            cartItem={cartItem}
            title={"Reports"}
            background={"background_reports.png"}
          ></NotSubscribe>
        </>
      )}
    </>
  );
}